<template>
  <header class="header" :class="headerClass">
    <div
      class="container"
      :class="{
        'header-black': isMenuOpen,
        'header-white': !isMenuOpen && isHomePage,
      }"
    >
      <div class="header__content">
        <div class="header__content-left">
          <a class="header__logo" href="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="174"
              height="72"
              viewBox="0 0 174 72"
              style="width: 174px; height: 72px"
              fill="none"
            >
              <path
                d="M115.699 32.2734C115.377 29.5436 114.783 27.1416 113.496 24.676C112.858 23.4501 111.714 22.2342 111.06 21.527C110.502 20.921 109.692 20.4223 108.984 20.0329C107.2 19.0355 105.132 18.7216 103.114 19.0236C100.938 19.3514 98.8915 20.5117 97.3676 22.0813C96.461 23.017 95.7337 24.1078 95.0875 25.2482C95.0181 24.074 94.8946 22.6197 94.2504 21.6024C93.4942 20.4144 92.3136 20.2355 91.027 20.2177C89.9795 20.2038 89.4703 20.2336 88.3765 20.2614C88.2434 20.2654 86.7581 20.3448 86.3569 20.3985C84.4684 20.6567 84.4529 23.8694 84.2755 25.6376C84.0343 28.0257 83.8974 30.4297 83.8222 32.8317C83.7469 35.18 83.7334 37.5284 83.7334 39.8827C83.7334 41.1244 83.7566 43.7629 83.7392 45.1735C83.689 49.1967 83.7604 51.8153 83.7045 55.8424C83.6717 58.2464 83.7161 59.0431 83.6717 60.4617C83.5965 62.8518 83.5868 64.8803 83.7778 67.2246C83.9842 69.7757 86.5845 70.1611 88.7816 70.2167C90.9845 70.2644 93.7218 69.7677 93.8819 67.2544C93.9494 66.2034 93.9436 65.1524 93.9089 64.1074C93.8742 62.8041 93.8472 61.4928 93.8337 60.1895C93.8125 57.7458 93.826 58.4292 93.8549 55.9934C93.8761 54.1974 93.961 52.5841 93.988 50.7881C97.792 52.2345 101.783 53.1067 105.724 52.0418C106.76 51.7616 108.454 51.1696 109.3 50.6351C110.539 49.8523 111.316 49.2046 112.221 48.3225C114.09 46.5026 115.234 43.8125 115.572 41.2258C115.936 38.4741 116.031 35.0271 115.701 32.2754L115.699 32.2734ZM105.811 43.6298C105.477 44.5278 104.445 45.6483 103.166 46.1271C101.322 46.8205 98.8993 46.7967 97.2403 45.8291C96.6211 45.4675 95.9459 44.5894 95.6894 43.7549C95.4251 42.8947 95.1686 41.3191 95.1686 40.2403C95.1686 38.7046 95.4675 36.4198 95.5621 35.8575C95.6084 35.5853 95.9363 34.288 96.3703 33.1674C96.7831 32.0986 97.52 31.0793 97.5258 31.0793C97.5258 31.0793 98.0042 30.3383 98.7912 29.8813C99.3757 29.5416 100.458 29.1244 101.538 29.2416C102.144 29.3071 103.502 29.7343 104.183 30.7078C105.016 31.8999 105.595 33.3025 105.886 34.6257C106.293 36.4714 106.415 37.8463 106.42 39.2768C106.43 41.2735 106.255 42.4238 105.811 43.6258V43.6298Z"
                fill="white"
              />
              <path
                d="M151.785 32.2734C151.463 29.5436 150.869 27.1416 149.582 24.676C148.943 23.4501 147.8 22.2342 147.146 21.527C146.588 20.921 145.778 20.4223 145.07 20.0329C143.286 19.0355 141.218 18.7216 139.2 19.0236C137.024 19.3514 134.977 20.5117 133.454 22.0813C132.547 23.017 131.82 24.1078 131.173 25.2482C131.104 24.074 130.981 22.6197 130.336 21.6024C129.58 20.4144 128.4 20.2355 127.113 20.2177C126.065 20.2038 125.556 20.2336 124.462 20.2614C124.329 20.2654 122.844 20.3448 122.443 20.3985C120.554 20.6567 120.539 23.8694 120.361 25.6376C120.12 28.0257 119.983 30.4297 119.908 32.8317C119.833 35.18 119.819 37.5284 119.819 39.8827C119.819 41.1244 119.842 43.7629 119.825 45.1735C119.775 49.1967 119.846 51.8153 119.79 55.8424C119.758 58.2464 119.802 59.0431 119.758 60.4617C119.682 62.8518 119.673 64.8803 119.864 67.2246C120.07 69.7757 122.67 70.1611 124.868 70.2167C127.07 70.2644 129.808 69.7677 129.968 67.2544C130.035 66.2034 130.03 65.1524 129.995 64.1074C129.96 62.8041 129.933 61.4928 129.92 60.1895C129.898 57.7458 129.912 58.4292 129.941 55.9934C129.962 54.1974 130.047 52.5841 130.074 50.7881C133.878 52.2345 137.869 53.1067 141.81 52.0418C142.846 51.7616 144.54 51.1696 145.386 50.6351C146.625 49.8523 147.402 49.2046 148.307 48.3225C150.176 46.5026 151.32 43.8125 151.658 41.2258C152.022 38.4741 152.117 35.0271 151.787 32.2754L151.785 32.2734ZM141.897 43.6298C141.563 44.5278 140.531 45.6483 139.252 46.1271C137.408 46.8205 134.985 46.7967 133.326 45.8291C132.707 45.4675 132.032 44.5894 131.775 43.7549C131.511 42.8947 131.254 41.3191 131.254 40.2403C131.254 38.7046 131.553 36.4198 131.648 35.8575C131.694 35.5853 132.022 34.288 132.456 33.1674C132.869 32.0986 133.606 31.0793 133.612 31.0793C133.612 31.0793 134.09 30.3383 134.877 29.8813C135.462 29.5416 136.544 29.1244 137.624 29.2416C138.23 29.3071 139.588 29.7343 140.269 30.7078C141.102 31.8999 141.681 33.3025 141.972 34.6257C142.379 36.4714 142.501 37.8463 142.506 39.2768C142.516 41.2735 142.34 42.4238 141.897 43.6258V43.6298Z"
                fill="white"
              />
              <path
                d="M78.7681 29.6489C78.608 32.2873 78.4113 35.2694 78.3746 37.9158C78.338 40.6536 78.3881 43.0655 78.637 45.7874C78.7527 47.0987 79.1829 48.6404 78.4981 49.8285C77.7766 51.0742 76.2547 51.0484 75.0741 51.0742C72.9753 51.1318 69.968 50.9927 68.365 49.2344C66.7119 47.4205 66.7987 44.2278 66.8064 41.8377C66.8141 39.084 66.8276 36.3363 66.8507 33.5827C66.872 30.837 66.9241 28.0813 67.142 25.3435C67.2578 23.925 67.3388 22.425 68.068 21.2111C68.5348 20.4362 68.8839 20.1342 69.5861 19.7528C69.86 19.6038 70.5081 19.3594 70.7589 19.2759C72.1497 18.809 73.3997 18.9104 74.8561 18.96C76.1814 19.0018 77.6532 19.1667 78.4692 20.5276C79.2041 21.7654 79.0016 23.3806 78.9649 24.7992C78.9283 26.4164 78.8627 28.0316 78.7681 29.6489Z"
                fill="white"
              />
              <path
                d="M37.256 43.1688C36.9435 44.7881 36.1506 45.9463 34.8177 47.2119C33.3902 48.5748 31.8335 49.2662 29.9875 49.8027C28.1028 50.345 25.5276 50.6192 23.5658 50.4563C19.6152 50.1305 17.0516 47.951 15.7688 44.3033C15.057 42.2867 14.7194 40.1867 14.5728 38.0608C14.4146 35.8555 14.3625 33.5608 14.3143 31.3535C14.2236 27.1515 14.3259 24.374 14.2912 19.9892C12.9505 19.9097 11.2067 19.9197 9.51108 19.6952C8.13184 19.5124 7.32744 19.5481 6.27228 18.3739C5.64342 17.6667 5.57205 16.3673 5.61834 15.4097C5.66464 14.4779 6.20669 12.8587 7.38146 12.8209C9.88916 12.7355 12.1017 12.8527 14.5844 12.9381C14.7715 10.1845 14.6249 8.0646 15.1013 5.35067C15.1843 4.86789 15.6395 3.77318 15.9482 3.40562C16.2838 3.00628 16.7969 2.72019 17.3062 2.53542C18.153 2.22747 21.6619 1.70097 23.5311 3.08575C24.484 3.79106 24.6866 5.00497 24.7251 6.16525C24.756 7.38512 24.6171 8.47983 24.6229 9.69971C24.6287 10.854 24.5998 12.0362 24.5998 13.1925C26.9358 13.2322 29.4261 13.0951 31.7641 13.1666C33.016 13.2044 33.3787 13.5978 33.6179 14.7302C33.7606 15.4057 33.7838 16.0415 33.7375 16.6931C33.6873 17.3766 33.5503 18.1355 33.153 18.6819C32.6553 19.3653 31.9454 19.5084 31.222 19.6177C30.4408 19.7369 29.1464 19.8442 28.3671 19.9077C27.0785 20.013 25.8903 20.0647 24.6017 20.1561C24.6075 22.1786 24.648 23.2773 24.6596 25.2998C24.6731 27.5767 24.6827 29.8376 24.6943 32.1144C24.7001 33.8628 24.621 36.4218 25.0473 38.1324C26.0446 42.1119 29.3335 42.3046 32.2425 40.4648C33.124 39.9066 35.6086 38.941 36.5114 39.6741C37.6032 40.5602 37.4508 42.1675 37.2579 43.1708L37.256 43.1688Z"
                fill="white"
              />
              <path
                d="M62.8596 25.7449C62.7188 27.1316 62.6648 27.9283 62.5336 29.2833C62.4623 30.0164 61.9299 30.4793 61.2663 30.3879C60.1031 30.227 58.8705 30.3005 57.9291 30.4416C57.3697 30.525 57.0032 30.6542 56.4496 30.825C55.4214 31.1469 54.5476 31.7866 53.9727 32.6866C53.2436 33.829 52.5607 35.6886 52.335 37.5443C52.252 38.2297 52.2424 39.2767 52.2424 39.3503C52.2212 41.6529 52.2019 42.7278 52.225 45.0304C52.2366 46.2006 52.2463 47.4205 51.9395 48.4894C51.627 49.596 50.7108 50.047 49.6614 50.2338C47.6649 50.5934 45.5873 50.496 43.6448 49.8464C42.6823 49.5245 41.791 48.8192 41.2664 47.8854C40.734 46.9437 40.8227 45.8013 40.8073 44.7543C40.7571 40.1887 40.7127 36.229 40.6607 31.6634C40.6394 29.4442 40.6066 27.0144 40.5854 24.7872C40.57 23.6448 40.7494 22.119 41.5808 21.2448C42.281 20.5197 43.6197 20.2932 44.401 20.2495C45.6143 20.1799 47.8481 20.0647 49.2081 20.3726C51.4033 20.8713 52.2598 22.7707 52.4507 24.8488C52.4797 25.1468 52.4951 25.4468 52.5086 25.7449C52.9021 25.1548 53.3091 24.5786 53.7393 24.0104C54.97 22.3892 56.5788 20.0051 58.6197 19.7349C61.2721 19.3852 63.2435 19.7051 63.1799 22.1428C63.1509 23.2395 62.9735 24.6104 62.8577 25.7449H62.8596Z"
                fill="white"
              />
              <path
                d="M77.875 9.26262C77.7593 10.3732 77.4969 11.5514 76.8507 12.4732C76.1679 13.4646 75.429 14.2395 74.3411 14.6666C73.3168 15.064 71.9279 15.0978 70.8457 14.8594C69.7269 14.605 68.7759 13.7646 68.311 12.6918C67.7805 11.454 67.8423 10.3156 67.9522 8.99043C68.0197 8.17983 68.1702 7.51029 68.3014 6.79108C68.367 6.43743 68.5309 6.04008 68.7778 5.51557C69.0479 4.94537 69.3643 4.54206 69.833 4.16854C70.3673 3.74337 70.8303 3.48311 71.5788 3.26655C72.7998 2.91489 74.0845 2.97449 75.2014 3.5745C77.169 4.63345 78.0988 7.06327 77.8731 9.26262H77.875Z"
                fill="white"
              />
              <path
                d="M167.757 29.6489C167.597 32.2873 167.45 34.9615 167.414 37.6079C167.377 40.3456 167.377 43.0655 167.626 45.7874C167.742 47.0987 168.172 48.6404 167.487 49.8285C166.766 51.0742 165.244 51.0484 164.063 51.0742C161.964 51.1318 158.957 50.9927 157.354 49.2344C155.701 47.4205 155.788 44.2278 155.795 41.8377C155.803 39.084 155.816 36.3363 155.84 33.5827C155.861 30.837 155.913 28.0813 156.131 25.3435C156.247 23.925 156.328 22.425 157.057 21.2111C157.524 20.4362 157.873 20.1342 158.575 19.7528C158.849 19.6038 159.497 19.3594 159.748 19.2759C161.139 18.809 162.389 18.9104 163.845 18.96C165.17 19.0018 166.642 19.1667 167.458 20.5276C168.193 21.7654 167.99 23.3806 167.954 24.7992C167.917 26.4164 167.852 28.0316 167.757 29.6489Z"
                fill="white"
              />
              <path
                d="M166.866 9.26262C166.75 10.3732 166.488 11.5514 165.842 12.4732C165.159 13.4646 164.42 14.2395 163.332 14.6666C162.308 15.064 160.919 15.0978 159.837 14.8594C158.718 14.605 157.767 13.7646 157.302 12.6918C156.771 11.454 156.833 10.3156 156.943 8.99043C157.011 8.17983 157.161 7.51029 157.292 6.79108C157.358 6.43743 157.522 6.04008 157.769 5.51557C158.039 4.94537 158.355 4.54206 158.824 4.16854C159.358 3.74337 159.821 3.48311 160.57 3.26655C161.791 2.91489 163.075 2.97449 164.192 3.5745C166.16 4.63345 167.09 7.06327 166.864 9.26262H166.866Z"
                fill="white"
              />
            </svg>
          </a>
          <div v-if="isMenuOpen" class="overlay" @click="toggleMenu"></div>

          <!-- Меню -->
          <nav class="header__menu" :class="{ open: isMenuOpen }">
            <!-- Крест -->
            <div class="menu__close" @click="toggleMenu">×</div>
            <!-- Список -->
            <ul class="header__menu-list">
              <li class="header__menu-item">
                <template v-if="isHomePage">
                  <a
                    href="#values"
                    class="header__menu-link"
                    @click="handleMenuClick('#values')"
                    >Ценности</a
                  >
                </template>
                <template v-else>
                  <router-link to="/#values" class="header__menu-link"
                    >Ценности</router-link
                  >
                </template>
              </li>
              <li class="header__menu-item">
                <template v-if="isHomePage">
                  <a
                    href="#about-us"
                    class="header__menu-link"
                    @click="handleMenuClick('#about-us')"
                    >О нас</a
                  >
                </template>
                <template v-else>
                  <router-link to="/#about-us" class="header__menu-link"
                    >О нас</router-link
                  >
                </template>
              </li>

              <li class="header__menu-item">
                <template v-if="isHomePage">
                  <a
                    href="#tours"
                    class="header__menu-link"
                    @click="handleMenuClick('#tours')"
                    >Туры</a
                  >
                </template>
                <template v-else>
                  <router-link to="/#tours" class="header__menu-link"
                    >Туры</router-link
                  >
                </template>
              </li>
              <li class="header__menu-item">
                <template v-if="isHomePage">
                  <a
                    href="#faq"
                    class="header__menu-link"
                    @click="handleMenuClick('#faq')"
                    >FAQ</a
                  >
                </template>
                <template v-else>
                  <router-link to="/#faq" class="header__menu-link"
                    >FAQ</router-link
                  >
                </template>
              </li>
            </ul>
            <div class="header__menu-bottom">
              <div class="header__menu-networks" v-if="isMenuOpen">
                <a
                  :href="$links.youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="@assets/svg/Icon-Youtube-pink.svg"
                    alt="Иконка Ютуба"
                  />
                </a>
                <a
                  class="with-dot"
                  :href="$links.instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="@assets/svg/Icon-Instagram-pink.svg"
                    alt="Иконка Инстаграмма"
                  />
                </a>
                <a
                  :href="$links.telegramChannel"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="@assets/svg/Icon-Telegram-pink.svg"
                    alt="Иконка Телеграма"
                  />
                </a>
              </div>
              <p class="gray">
                *Instagram - проект Meta Platforms Inc, деятельность <br />
                которой запрещена на территории РФ
              </p>
            </div>
          </nav>
        </div>
        <div class="header__content-right">
          <!-- Бургер-кнопка -->
          <div class="burger" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="header__action" v-if="isButtonVisible">
            <CustomButton
              :to="to"
              size="medium"
              :text="text"
              color="pink"
            ></CustomButton>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import CustomButton from "./CustomButton.vue";
export default {
  name: "Header",
  data() {
    return {
      isMenuOpen: false, // Состояние меню
      isMobile: false,
      isButtonVisible: true,
    };
  },
  components: {
    CustomButton,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen; // Открыть/закрыть меню
    },
    checkScreenWidth() {
      const width = window.innerWidth;

      this.isButtonVisible = width >= 1024; // Показываем кнопку, если ширина экрана больше или равна 1024px
      this.isMobile = width <= 1024; // Устанавливаем флаг для мобильной версии
    },
    handleMenuClick(target) {
      if (this.isHomePage) {
        this.smoothScroll(target); // Если мы на домашней странице, выполняем плавный скролл
      }
      if (this.isMobile) {
        this.toggleMenu();
      }
    },
    smoothScroll(target) {
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  watch: {
    $route() {
      this.isMenuOpen = false; // Закрываем меню при смене маршрута
    },
  },

  computed: {
    // Динамическое добавление класса в зависимости от маршрута

    headerClass() {
      if (this.$route.name === "TourPage") {
        return "header-blue"; // Если на странице тура, хедер синим
      }
      if (this.isMobile) {
        return "header-white"; // На мобильной версии всегда белый
      }
      return this.$route.name === "HomePage" || this.$route.name === "TourPage"
        ? "header-white"
        : "header-black";
    },
    isHomePage() {
      return this.$route.name === "HomePage";
    },
  },
  mounted() {
    this.checkScreenWidth(); // Проверяем ширину экрана при загрузке
    window.addEventListener("resize", this.checkScreenWidth); // Следим за изменением размера экрана
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth); // Убираем слушатель
  },
};
</script>
<style lang="scss" scoped>
.header-white {
  .header__menu-link {
    color: $white-link-color;
  }

  .header__logo path {
    fill: $white-logo-color;
  }
}
.header-black {
  .header__menu-link {
    color: $black-link-color;
  }

  .header__logo path {
    fill: $black-logo-color;
  }
}
.header.header-blue {
  background-color: $blue;
}

.header {
  background-color: transparent;
  height: 168px;
  display: flex;
  align-items: center;
  position: absolute; // Закрепляем хедер сверху страницы при прокрутке
  width: 100%; /* Растягивает хедер на всю ширину */
  z-index: 10; /* Поднимает хедер над другими элементами */
  .container {
    max-width: 1920px; /* Ограничение максимальной ширины */
    width: 100%;
    margin: 0 auto; /* Центрируем контейнер */
  }
  &__content {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    &-left {
      display: flex;
      align-items: center;
      gap: 145px;
    }
    &-right {
      width: 25%;
    }
  }

  &__logo {
    flex-shrink: 0;
  }
  &__logo svg {
    display: block;
    width: 174px;
    aspect-ratio: 174 / 72; /* Поддерживает пропорции */
  }

  &__menu {
    width: 584px;
    &-list {
      display: flex;
      align-items: center;
      gap: 40px;
      padding-left: 0;
      margin: 0;
      list-style: none;
    }

    &-item {
      list-style: none;
    }

    &-link {
      @extend .coolvetica;
      text-decoration: none;
      transition: color 0.3s;
      color: $white;
      padding: 16px;
      font-size: 32px;
      position: relative;
      z-index: 1;
      line-height: normal;
      //* Обводка
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        width: 120%;
        height: 120%;
        background: url("@/assets/svg/outline.svg") no-repeat center;
        background-size: contain;
        z-index: 0;
        transition: transform 0.3s ease-in-out;
      }
      &:hover:after {
        transform: translate(-50%, -50%) scale(1.1); // Показываем обводку
      }
      &--values:after {
        width: 170%;
        height: 150%;
      }
    }
  }
  &__action {
    display: flex;
    align-items: center;
    width: 100%;
  }
}
// Для последнего элемента с классом --values
.header__menu-item {
  &:last-child {
    .header__menu-link--values:after {
      width: 200%;
      height: 200%;
    }
  }
}
// Адаптивность для экранов между 1200px и 1920px
@media (max-width: 1920px) and (min-width: 1600px) {
  .header__menu-link {
    font-size: clamp(24px, 2vw, 32px);
  }

  .header__menu-list {
    justify-content: flex-start; /* Переносим ссылки влево */
    gap: 20px; /* Уменьшаем расстояние между ссылками */
  }

  .header__content-left {
    gap: 36px; /* Уменьшаем разрыв между логотипом и меню */
  }
}
@media (max-width: 1600px) and (min-width: 1024px) {
  .header__menu-link {
    font-size: 24px;
  }
  .header__menu-list {
    gap: 20px;
  }
  .header {
    &__content {
      &-left {
        gap: 45px;
      }
    }
    &__logo {
      svg {
        width: 148px;
        height: 61px;
      }
    }
    &__action {
      .btn {
        max-width: 252px;
        gap: 12px;
        height: 61px;
        font-size: 24px;
      }
    }
  }
}

// БУРГЕР МЕНЮ
.burger {
  display: none;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;

  span {
    width: 40px;
    height: 3px;
    background-color: $white;
    border-radius: 3px;
    transition: all 0.3s ease;
  }
}

.header__menu {
  display: flex;
}

// Адаптивность для мобильных экранов
@media (max-width: 1024px) {
  .burger {
    display: flex;
  }

  .header {
    &__content {
      &-right {
        width: 5%;
      }
    }

    &__action {
      display: none;
    }

    &__logo {
      z-index: 15;
    }

    &__menu {
      display: none;
      flex-direction: column;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background-color: $white;
      &-list {
        padding-top: 150px;
        gap: 30px;
        z-index: 10;
        display: flex;
        flex-direction: column;
        font-size: 20px;
      }
      &-item {
      }
      &-link {
        color: $black !important;
      }
      &-bottom {
        p {
          margin-top: 20px;
          color: $form-gray-lighter;
          text-align: center;
          @include manrope(400);
          font-size: 20px;
        }
      }
      &-networks {
        display: flex;
        justify-content: center;
        gap: 13px;
        margin-top: 32px;
        img {
          width: 64px;
          height: 64px;
        }
      }

      &.open {
        height: 580px;
        display: block;
        z-index: 10;
      }
    }
  }

  .menu__close {
    position: absolute;
    top: 40px;
    right: 40px;
    font-size: 80px;
    font-weight: bold;
    cursor: pointer;
  }
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3); // Черный фон с прозрачностью 30%
    z-index: 9; // Должен быть ниже, чем бургер-меню, но выше контента
  }
  .with-dot {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: -12px;
      right: -12px;
      width: 17px;
      height: 17px;
      background-image: url("@assets/svg/dot-pink.svg");
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
}

@media (min-width: 1024px) {
  .gray {
    display: none;
  }
}
@media (max-width: 1024px) {
  .header {
    background-color: $blue;
    &__menu {
      &.open {
        z-index: 12;
      }
    }
  }
}

@media (max-width: 768px) {
  .header__content-right {
    width: 10%;
  }

  .header {
    height: 84px;
    &__logo {
      svg {
        width: 96px;
        height: auto;
      }
    }
    &__menu {
      &.open {
        height: 420px;
        z-index: 12;
      }
      &-link {
        font-size: 20px;
      }
      &-networks {
        display: flex;
        justify-content: center;
        gap: 13px;
        margin-top: 32px;
        img {
          width: 44px;
          height: 44px;
        }
      }
      &-list {
        padding-top: 80px;
      }
    }
    .burger {
      span {
        width: 30px;
        height: 2px;
      }
    }
  }
  .header .menu__close {
    position: absolute;
    top: 8px;
    right: 25px;
    font-size: 60px;
    font-weight: bold;
    cursor: pointer;
  }
  .header .gray {
    font-size: 12px;
  }

  .with-dot {
    &::after {
      top: -8px;
      right: -8px;
      width: 10px;
      height: 10px;
    }
  }
}

@media (min-width: 1025px) {
  .menu__close {
    display: none;
  }
}
</style>
